import React, { FC } from 'react';
import { ChangeIngestionMode } from 'new/elements/ChangeIngestionMode/ChangeIngestionMode';
import { changeIngestionAvailability } from 'js/constants/config';
import Tooltip from 'js/components/elements/mui/Tooltip';
import { ReactComponent as InfoIcon } from 'new/components/icons/fi-rr-info.svg';
import classes from './ChangeIngestionMode.module.scss';

type Options = {
  resourceType: 'source' | 'nexset' | 'sink';
};

export default function withChangeIngestion(options: Options) {
  function wrapped(WrappedComponent: FC) {
    return (props: any) => {
      const { data, flow } = props;

      const flowType = data?.flow_type || flow?.flow_type;

      const availableOptions =
        changeIngestionAvailability?.[options?.resourceType]?.[flowType] || [];

      const canShowIngestionModeToggle = availableOptions?.includes(data.connector_type);
      const ingestionToggleMenuItems = canShowIngestionModeToggle
        ? [
            {
              label: (
                <>
                  <>Sampling Mode</>
                  <Tooltip
                    tooltipTheme="fieldInfo"
                    title={
                      <>
                        <p>
                          This source is currently in <b>Sampling Mode</b>. In this mode, the
                          platform efficiently analyzes a subset of your data, enabling quicker
                          setup and testing without the overhead of full ingestion.
                        </p>
                        <p>
                          The platform will seamlessly transition to full ingestion once a
                          destination is configured, but you have the flexibility to exit sampling
                          mode at any time by toggling the switch.
                        </p>
                      </>
                    }
                  >
                    <InfoIcon className={classes.infoIcon} />
                  </Tooltip>
                </>
              ),
              endView: <ChangeIngestionMode data={data} />,
              preventCloseOnClick: true,
            },
          ]
        : [];

      return <WrappedComponent ingestionToggleMenuItems={ingestionToggleMenuItems} {...props} />;
    };
  }

  return wrapped;
}
